import { Close as ResetIcon } from "@mui/icons-material";
import { Box, IconButton, Stack } from "@mui/material";
import type { FC } from "react";
import MultiSelect from "../../components/select/MultiSelect";
import type { SelectedTag } from "../../components/tagSelect/TagSelect";
import TagSelect from "../../components/tagSelect/TagSelect";
import AgentMultiSelect from "../../sharedComponents/agentSelect/AgentMultiSelect";
import { CUSTOMER_STATUS_VALUES } from "../customerStatus";
import type { CustomerStatus } from "../customersApi";
import type { CustomersSearchCriteria } from "../list/useCustomersSearch";
import { useCustomerTagsByCategory } from "../useCustomerTagsByCategory";

const tagCategories = ["Oferta dla", "Obszar"] as const;

const statusValues = CUSTOMER_STATUS_VALUES.map((value) => ({ value }));

interface Props {
  readonly filters: CustomersSearchCriteria;
  readonly onChange: (change: Partial<CustomersSearchCriteria>) => void;
  readonly onClear: () => void;
}

const CustomerMapFilters: FC<Props> = ({ filters, onChange, onClear }) => {
  const customerTagsByCategory = useCustomerTagsByCategory();
  return (
    <Stack spacing={2}>
      <AgentMultiSelect
        label="Opiekun"
        agentIds={filters.accountManagerIds}
        onChange={(accountManagerIds) => onChange({ accountManagerIds })}
      />
      <MultiSelect
        label="Status"
        fullWidth
        selected={filters.statuses}
        values={statusValues}
        onSelect={(statuses) => onChange({ statuses: statuses as CustomerStatus[] })}
      />
      {tagCategories.map((category) => (
        <TagSelect
          key={category}
          label={category}
          tags={filters.marketSegment.filter((tag) => tag.category === category)}
          availableTags={{ [category]: customerTagsByCategory[category] ?? [] }}
          maxVisibleTags={2}
          onChange={(tags) => onChange({ marketSegment: replaceCategoryTags(filters.marketSegment, category, tags) })}
        />
      ))}
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <IconButton aria-label="Wyczyść filtry" onClick={onClear}>
          <ResetIcon />
        </IconButton>
      </Box>
    </Stack>
  );
};

function replaceCategoryTags(tags: SelectedTag[], category: string, categoryTags: SelectedTag[]): SelectedTag[] {
  return [...tags.filter((tag) => tag.category !== category), ...categoryTags];
}

export default CustomerMapFilters;
